var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},[_c('webTop'),_c('section',{staticClass:"app-main"},[(this.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{key:_vm.key})],1):_vm._e(),(!this.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),_c('webFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }